import { Component, Inject, OnInit } from "@angular/core";
import { EmployeesListComponent } from "../employees-list.component";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { EmployeesListModel } from "../employees-list.model";
import { EmployeesListService } from "../employees-list.service";

@Component({
    selector: "configurar-acceso-empleado",
    templateUrl: "./config-acceso.component.html",
    styleUrls: ["./config-acceso.component.css"],
    standalone: false
})
export class ConfigurarAccesoEmpleadoComponent implements OnInit {

  // #region Propiedades del componente
  empleado: EmployeesListModel = null;
  form: UntypedFormGroup = null;
  // #endregion

  hidePassword: boolean = true;


  constructor(
    public dialogRef: MatDialogRef<EmployeesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    protected employeesService: EmployeesListService
  ) { }

  ngOnInit(): void {
    this.empleado = this.data.empleado;
    this.inicializarFormulario();
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  // #region Métodos del componente

  cancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.form.valid) {
      // Actualización de los datos del empleoado
      this.empleado.email = this.form.value.email;
      this.empleado.password = this.form.value.password;
      this.empleado.active = true;

      // Guardado de los datos del empleado utilizando el servicio correspondiente
      this.employeesService.editData(this.empleado.uid.toString(), this.empleado).then(
        data => {
          this.snackBar.open('Datos guardados', 'Cerrar', {
            duration: 2000,
          });

          // Actualizar la propiedad del empleado que dice si tiene el acceso configurado
          this.empleado.datosAccesoConfigurados = true;

          this.dialogRef.close(this.empleado);
        }
      );
    }
  }

  // #endregion

  // #region Métodos privados del componente

  private inicializarFormulario(): void {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl(this.empleado.email, [Validators.required, Validators.email]),
      password: new UntypedFormControl(this.empleado.password, [Validators.required, Validators.minLength(6)]),
    });
  }

  // #endregion
}
